import { AlertTitle } from "@mui/material";
import { RestrictedAlert } from "@orion/OrionComponents/OrionSnackbar";

import {
  SMS_NOT_ENABLED_REASON,
  SMS_NOT_ENABLED_TITLE,
  useIsTextMessagingActive,
} from "@/api/siteCapabilities";
import { useIsDemoUser } from "@/utils/demoMode";

/**
 * Non-blocking banner shown when a site doesn't have text messaging activated
 * (FOG-1762). Purely informational — drop it at the top of any text-authoring
 * form (tile or broadcast). Renders nothing when SMS is active. Restricting
 * scheduling/sending is handled separately at the broadcast confirm step.
 */
export function SmsNotEnabledBanner({ siteId }: { siteId: string }) {
  const isTextActive = useIsTextMessagingActive(siteId);
  // "Contact your rep" is meaningless to demo prospects.
  const isDemoUser = useIsDemoUser();
  if (isTextActive || isDemoUser) return null;

  return (
    <RestrictedAlert>
      <AlertTitle sx={{ fontWeight: 700 }}>{SMS_NOT_ENABLED_TITLE}</AlertTitle>
      {SMS_NOT_ENABLED_REASON}
    </RestrictedAlert>
  );
}
